import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Play(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M4.52 2.122a1 1 0 0 1 1.02.037l14 9a1 1 0 0 1 0 1.682l-14 9A1 1 0 0 1 4 21V3a1 1 0 0 1 .52-.878ZM6 4.832v14.336L17.15 12 6 4.832Z" }) }));
}
